import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/free-regular-svg-icons';
import { SectionHeader_2, Card_6 } from '../../../../../component/landingComponent'
const CbGoldStandard = () => {
    return (
        <>
            <div className='row pt-20 px-10 mb-20'>
                <div className='col-md-12 text-center'>
                    <SectionHeader_2
                        title= {`Gold Standard`}
                    />
                </div>
                <div className='row mt-20 border px-10 br-20'>
                    <div className='col-md-5 pe-15 m-auto py-10'>
                        <img src="/assets/img/gold-standard.jpg" alt="app image" className="radius-20" style={{}} />
                    </div>
                    <div className='col-md-7 m-auto'>
                        <div className='mt-6'>
                            <ul className="list-check ">
                                <li className='d-flex text-gray-700 fs-3'>
                                    <FontAwesomeIcon icon={faCircleCheck} className='me-2'/>
                                    With our deep expertise in Conversational/Agentic AI, we will build the best-in-class AI Agents for you.
                                </li>
                                <li className='d-flex text-gray-700 fs-3'>
                                    <FontAwesomeIcon icon={faCircleCheck} className='me-2'/>
                                    Leverage  our deep expertise to build fulfilling experiences for your customers in the fastest and most efficient possible way.
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export {CbGoldStandard}